import * as Common from '@/tenantCatalog/common';

export class Tenant extends Common.ObjectBase{
  constructor(){
    super('Tenant')
  }
  public id: string = '';
  public name: string = '';
  public databaseName: string = '';
  public adminId :string = '';
  public adminName:string= '';
  public licenseFlag :number;
  public licenseCount :number;
  public storageSize :number;
  public paymentAgent: number;
  public paymentStatus: number;
  public subscriberCode: string;
  public firstDeductionMonth: Date;
  public isOverdue: boolean;
  public signupTimestamp: Date;      
  public paidStartDate: Date;      
  public paidEndDate: Date;      
  public trialExpiry: Date;
  public retrialPossible: boolean;
  public provisioningTemplate:string = null;
  public roadmapRate : number;
  public conversionFlag : Common.conversionFlags; //コンバージョンフラグ
  public cohortWeek : Date;
  public elapsedWeek : number;
  public isPartner: boolean;
  public partnerId: string;
  public bankCode: string; 
  public bankName: string; 
  public bankBranchCode: string; 
  public bankBranchName: string; 
  public bankAccountCategory:Common.BankAccountCategoryTypes = BankAccountCategoryTypes.Default;     
  public bankAccountCode: string; 
  public bankAccountName : string; 
  public partnerKey: string; 
  public mfaEnabled:boolean;
  public safeIntroducsionPackExpiry: Date;
  public telNo: string;
  public updateInitialAmountFlag: boolean;

  public get trialExpiry2(){
    return this.paymentStatus == paymentStatusFlags.Trial ? this.trialExpiry : null;
  }
 public get formURI(){
   return encodeURI(String.format('?userId={0}&userName={1}&tenantId={2}&tenantName={3}&campaignId={4}', this.adminId,this.adminName,this.id,this.name,1));
 }  
}
export enum BankAccountCategoryTypes
{
    Default = 0, //
    Saving = 1, // 普通
    Checking = 2, // 当座
    Deposit = 3, // 貯蓄
    Other = 4 // その他
}
    export enum ShipmentFlags
    {      
        Default, //未設定
        Under20,//～20件
        Under50,//21～50件                
        Under100,//51～100件          
        Under500,//101～500件   
        Over501,//501件～
    }
export enum paymentAgentFlags {default, payJp}
export enum paymentStatusFlags {       
        Trial,
        Paid,
        Cancelled,         
        TrialCancelled}
export class TenantQuery extends Common.LoadQuery {
  constructor(){
    super('TenantQuery',Tenant);
    this.sort = 'id';    
  }
  public id: string = '';
  public name: string = '';
  public tenantVersion: Common.TenantVersions = null;
  public adminId: string ='';
  public adminName: string ='';
  public databaseName: string = '';
  public licenseFlag:number;
  public optionFlag:number;  
  public paymentStatus:number;
  public paymentAgent:number;
  public partnerId:string = null;
  public userReportCount:number;
}

export class TenantMasterQuery extends Common.LoadQuery {
  constructor(){
    super('TenantMasterQuery',Tenant);
  }
}

export class PrimeTenantMasterQuery extends Common.LoadQuery {
  constructor(){
    super('TenantMasterQuery',Tenant);
  }
  public primeOnly:boolean = true;
}

export class MonthCloseQuery extends Common.Query {
  constructor(tenants: Common.Tenant[]){
    super('MonthCloseQuery',null);
    this.tenants = tenants;
  }  
  public closingDate: Date = null;
  public tenants: Common.Tenant[] = null;
  public isAsync:boolean = true;
}
export class TrialCloseQuery extends Common.Query {
  constructor(tenants: Common.Tenant[]){
    super('TrialCloseQuery',null);
    this.tenants = tenants;    
  }  
  public tenants: Common.Tenant[] = null;
  public isAsync:boolean = true;  
}
export class SettlementQueryPayJP extends Common.Query {
  constructor(billings: Common.Billing[]){
    super('SettlementQueryPayJP',null);
    this.billings = billings;    
  }    
  public billings: Common.Billing[] = null;
  public isAsync:boolean = true;  
}

export class TenantCatalogCancelQuery extends Common.Query {
  constructor(tenant: Tenant){
    super('TenantCatalogCancelQuery',null);
    this.tenant = tenant;
  }    
  public tenant : Tenant = null;
}

export class EnableMFAQuery extends Common.Query {
  constructor(tenants: Common.Tenant[]){
    super('EnableMFAQuery',null);
    this.tenants = tenants;
  }  
  public tenants: Common.Tenant[] = null;
}

export class ObjectMigrationExecuteQuery extends Common.Query {
  constructor(tenants: Common.Tenant[]){
    super('ObjectMigrationExecuteQuery',null);
    this.tenants = tenants;
  }  
  public tenants: Common.Tenant[] = null;
  public isAsync:boolean = true;  
}

export class ChangeLicenseFlagQuery extends Common.Query {
  constructor(tenants: Common.Tenant[], changeLicenseFlag: Common.licenseFlags, telNo: string, updateInitialAmountFlag: boolean , dbName: string = null){
    super('ChangeLicenseFlagQuery',null);
    this.tenants = tenants;
    this.changeLicenseFlag = changeLicenseFlag;
    this.telNo = telNo;
    this.updateInitialAmountFlag = updateInitialAmountFlag;
    this.dbName = dbName;
  }
  public tenants: Common.Tenant[] = null;
  public isAsync:boolean = true;  
  public changeLicenseFlag: Common.licenseFlags;
  public telNo: string = "";
  public updateInitialAmountFlag: boolean = false;
  public dbName: string = null;
}

export class TransferTenantQuery extends Common.Query {
  constructor(tenants: Common.Tenant[],targetDbName:string){
    super('TransferTenantQuery',null);
    this.tenants = tenants;
    this.targetDbName = targetDbName;
  }  
  public tenants: Common.Tenant[] = null;
  public targetDbName :string = null;
  public isAsync:boolean = true;
}

// あんしん導入パック有効期限延長処理
export class ChangeSafeIntroductionPackExpiryQuery extends Common.Query {
  constructor(tenant: Tenant,  safeIntroductionPackExpiry: Date){
    super('ChangeSafeIntroductionPackExpiryQuery',null);
    this.tenant = tenant;
    this.safeIntroductionPackExpiry = safeIntroductionPackExpiry;
  }
  public tenant : Tenant = null;
  public safeIntroductionPackExpiry: Date = null;
}
export class EnableRetrialQuery extends Common.Query {
  constructor(tenant: Common.Tenant){
    super('EnableRetrialQuery',null);
    this.tenant = tenant;
  }  
  public tenant: Common.Tenant = null;
}
export class ExecutePaymentQuery extends Common.Query {
  constructor(tenant: Common.Tenant, subscriberCode: string, firstDeductionMonth: Date){
    super('ExecutePaymentQuery',null);
    this.tenant = tenant;
    this.subscriberCode = subscriberCode;
    this.firstDeductionMonth = firstDeductionMonth;
  }  
  public tenant: Common.Tenant = null;
  public subscriberCode: string = null;
  public firstDeductionMonth: Date = null;
}